import axios from "axios";
import {API_URL} from "../../Helper";

export const LOGIN_URL = API_URL + "login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = API_URL + "forgotPassword";
export const RESET_PASSWORD_URL = API_URL + "resetPassword";

export const ME_URL = API_URL + "me";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(data) {
  return axios.post(RESET_PASSWORD_URL, data);
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
